'use client'

const Features = () => {
  const features = [
    {
      title: 'No compromises',
      img: 'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/product_detail/icons/diamomd.png',
      description:
        'Crafted to perfection, without ever sacrificingbrilliance or size.',
    },
    {
      title: 'CERTIFIED EXCELLENCE',
      img: 'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/product_detail/icons/verifies.png',
      description: 'Every stone is authenticated for trust and beauty.',
    },
    {
      title: 'SUSTAINABLE  LUXURY',
      img: 'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/product_detail/icons/reverse.png',
      description: 'Ethical sourcing. Earth-conscious processes.',
    },
  ]

  return (
    <div className='flex flex-col md:grid md:grid-cols-3 gap-6 md:gap-8 mt-8 min-h-[211px] px-4 md:px-0'>
      {features.map((feature, index) => (
        <div
          key={index}
          className={`flex items-center justify-center md:justify-start gap-4 p-4
         `}
        >
          <div className='flex-shrink-0'>
            <img src={feature.img} alt='' className='w-8 h-8 md:w-10 md:h-10' />
          </div>
          <div className='flex flex-col'>
            <h1 className='uppercase font-barlowBold text-[14px] md:text-[16px] text-[#A08260] text-center md:text-left'>
              {feature.title}
            </h1>
            <h1 className='font-barlowNormal text-[12px] md:text-[14px] xlg:text-[18px] text-center md:text-left mt-1 text-white'>
              {feature.description}
            </h1>
          </div>
        </div>
      ))}
    </div>
  )
}
export const FeaturesSection = () => {
  return (
    <section className='mt-5 mx-[15px] md:mx-[0px]'>
      <div className='w-full min-h-[580px] md:mt-32 relative'>
        <div className="relative bg-[url('/product/details/above_all_bg.png')] bg-cover  bg-[#8A6F4F]/35 min-h-[580px] w-full">
          <div className='absolute bottom-0 left-0 right-0 h-[400px] bg-gradient-to-t from-[#000]/100 via-[#000]/60 to-transparent pointer-events-none'></div>

          <div className='relative z-10 flex flex-col py-4'>
            <div className='w-full flex flex-col justify-center items-center pt-4'>
              <img
                // height={112}
                // width={110}
                alt='gold icon'
                src={
                  'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Customization/Vertelier_trust_seal.png'
                }
                className='w-[32px] h-[32px] md:w-[112px] md:h-[110px]'
              />
              <h1 className='font-barlowSemiBold text-[#B3935C] text-[30px] md:text-[64px] md:mt-4 text-center'>
                You <span className='font-cambonLight'>above all</span>
              </h1>
              <h1 className='font-barlowMedium text-[#fff] text-[12px] md:text-[16px] w-[80%] text-center mt-2'>
                Our shopping experience is carefully designed with you in mind.
                Stress-free from start to finish with complimentary, no-hassle
                services—and that&apos;s our promise.
              </h1>
            </div>

            <Features />
          </div>
        </div>
      </div>
    </section>
  )
}
